import { Text } from 'foundations-components/components/Text';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { default as styled } from 'foundations-theming/utils';
import { getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { USD } from 'self-service-api/constants/CurrencyCodes';
import { useGetCurrencyStore, useSetCurrencyStore } from '../../context/CurrencyContext';
import { useGlobalLoadingState } from '../../context/GlobalLoadingStateContext';
import { validateCurrencyCode } from '../../utils/currencyUtils';
import { trackCurrencyPickerInteraction } from '../../utils/tracking/trackingEventUtils';
import { useQueryParamsEffect } from '../../utils/urls/appQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurrencyCodeToSymbol = {
  [CurrencyCodes.USD]: '$',
  [CurrencyCodes.EUR]: '€',
  [CurrencyCodes.GBP]: '£',
  [CurrencyCodes.AUD]: '$',
  [CurrencyCodes.JPY]: '¥',
  [CurrencyCodes.SGD]: '$',
  [CurrencyCodes.COP]: '$',
  [CurrencyCodes.CAD]: '$',
  [CurrencyCodes.INR]: '₹'
};
const CurrencySymbol = styled.span.withConfig({
  displayName: "MobileCurrencyPicker__CurrencySymbol",
  componentId: "lll8p1-0"
})(({
  theme
}) => {
  return {
    marginInlineStart: theme.space[50],
    [trellisBreakpoint.phone]: {
      display: 'none'
    }
  };
});
const MobileCurrencyPicker = () => {
  const setCurrencyStore = useSetCurrencyStore();
  const {
    availableCurrencyCodes,
    lockedCurrencyCode,
    displayedCurrencyCode
  } = useGetCurrencyStore(store => store);

  // Only update URL when we have valid currency data
  const isCurrencyDataLoading = useGlobalLoadingState('Currencies');
  useQueryParamsEffect({
    currencyCode: !isCurrencyDataLoading ? displayedCurrencyCode : undefined
  });
  const handleClick = selectedCurrencyCode => {
    const validatedCurrencyCode = validateCurrencyCode({
      availableCurrencyCodes,
      lockedCurrencyCode,
      displayedCurrencyCode,
      currencyCode: selectedCurrencyCode
    });
    const showCurrencyCodeUnit = validatedCurrencyCode === USD;
    setCurrencyStore({
      displayedCurrencyCode: validatedCurrencyCode,
      showCurrencyCodeUnit
    });
    trackCurrencyPickerInteraction({
      action: 'select currency',
      currency: validatedCurrencyCode
    });
  };
  return availableCurrencyCodes.length <= 1 ? null : /*#__PURE__*/_jsx(ButtonGroup, {
    orientation: "horizontal",
    inlineSize: "100%",
    marginBlock: "500",
    paddingInline: "300",
    display: "flex",
    justifyContent: "center",
    gap: "100",
    flexWrap: "wrap",
    children: availableCurrencyCodes.map(currency => {
      const selected = displayedCurrencyCode === currency;
      const gaClassName = getGAClassName(`currency-pricing-${currency.toLowerCase()}`);
      return /*#__PURE__*/_jsx(SelectableBox, {
        type: "default",
        selected: selected,
        onClick: () => handleClick(currency),
        padding: "200",
        "data-selenium-id": gaClassName,
        children: /*#__PURE__*/_jsx("div", {
          className: gaClassName,
          children: /*#__PURE__*/_jsxs(Text, {
            typography: "detail-200",
            as: "span",
            children: [currency, /*#__PURE__*/_jsx(CurrencySymbol, {
              children: CurrencyCodeToSymbol[currency]
            })]
          })
        })
      }, currency);
    })
  });
};
export default MobileCurrencyPicker;